// extracted by mini-css-extract-plugin
export default {"productGallery":"eJ-z","inQuickShop":"fJ-z"};